import {
    AUTH_USER
} from './actionTypes'

export const authUser = (payload) => ({
    type:AUTH_USER,
    payload:payload
}) 

